module.exports = __webpack_public_path__ + "images/motoguzzi00574ca96e766f840bfd49364bc7bb68.png";